<template>
    <el-popover
        v-model="visible"
        :width="width"
        :trigger="trigger"
        popper-class="export_task_popover"
    >
        <div class="export_task_inner" v-loading="loading">
            <div class="export_task__header">
                <h3 class="export_task__title">{{ this.title }}</h3>
                <div class="export_task__tishi_icon">
                    <el-popover placement="right" trigger="hover">
                        <div class="export_task__tishi">列表信息保留七天，之后将自动移除</div>
                        <as-icon slot="reference" name="tishi1"></as-icon>
                    </el-popover>
                </div>
            </div>
            <div class="export_task__body">
                <div v-if="listData.length == 0 && !loading" class="export_task__empty">
                    <as-icon name="wushuju"></as-icon>
                    <span>暂无导出任务</span>
                </div>
                <div class="export_task__item" v-for="(item, index) in listData" :key="index">
                    <img class="export_task__icon" src="./assets/excel.svg" alt="">
                    <div class="export_task__content">
                        <h4 class="export_task__label" :title="item.taskName">{{ item.taskName }}</h4>
                        <p class="export_task__time">{{ item.createTs }}</p>
                    </div>
                    <div class="export_task__status">
                        <span class="export_task_status_label" :class="item.taskStatus">{{ item.taskStatusLabel }}</span>
                        <span class="export_task__size">{{ item.fileSize }}</span>
                    </div>
                    <div class="export_task__action">
                        <div v-if="item.taskStatus == 'COMPLETED'" class="export_task__action_item" title="下载" @click="onDownload(item)"><as-icon name="xiashuju"></as-icon></div>
                        <div class="export_task__action_item" title="删除" @click="onDelete(item)"><as-icon name="shanshuju"></as-icon></div>
                    </div>
                </div>
            </div>
        </div>
        <span class="export_task__reference_wrapper" slot="reference">
            <slot>
                <as-icon class="export_task__reference" :class="{'export_task__reference_old': isOld}" name="daochubaobiao"></as-icon>
            </slot>
        </span>
    </el-popover>
</template>
<script>
import AsIcon from '@/components/icon'
import ExclusiveApi from '@/api/exclusive'
import Cookie from 'js-cookie'
import utils from '@/js/utils'
export default {
    name: 'ExportTaskPopover',
    components: {
        AsIcon
    },
    props: {
        isOld: Boolean,
        serviceName: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: '我的导出'
        },
        width: {
            type: Number,
            default: 410
        },
        trigger: {
            type: String,
            default: 'click'
        },
        placement: {
            type: String,
            default: 'bottom'
        },
        boundariesElement: {
            type: [String, Object],
            default: 'body'
        },
        loadData: Function,
        tenantId: String,
    },
    data() {
        return {
            visible: false,
            loading: false,
            listData: [],
        }
    },
    watch: {
        visible(newValue) {
            if (!newValue) return;
            if (this.loadData) {
                this.loading = true;
                this.loadData(this.loadDataFinish); 
            }else {
                this.initListData();
            }
        }
    },
    methods: {
        initListData() {
            this.listData = [];
            this.loading = true;
            ExclusiveApi.getExportTaskList({
                serviceName: this.serviceName,
                parentShopId: this.tenantId || Cookie.get("realParentShopId"),
                tenantId: this.tenantId,
            }).then(res => {
                const statusLabelMap = {
                    "COMPLETED": "成功",
                    "RUNNING": "进行中",
                    "FAILED": "失败",
                    "CANCELLED": "取消",
                    "CREATE": "进行中"
                }
                this.loading = false;
                const listData = res.content || [];
                if (listData.length > 0) {
                    for (let i = 0; i < listData.length; i++) {
                        const item = listData[i];
                        const { taskInfo, fileList } = item;
                        item.status = taskInfo.status;
                        item.taskId = taskInfo.id;
                        item.taskStatusLabel = statusLabelMap[taskInfo.taskStatus];
                        item.fileSize = fileList[0] ? Number((fileList[0]?.fileSizeBytes / 1024).toFixed(2)) + 'kb' : "";
                        item.taskName = taskInfo.taskName;
                        item.createTs = taskInfo.createTs;
                        item.taskStatus = taskInfo.taskStatus;
                        item.serviceName = taskInfo.serviceName;
                    }
                    this.listData = listData.sort((a, b) => {
                        return new Date(b.createTs).getTime() - new Date(a.createTs).getTime();
                    });
                }
            }).catch(err => {
                this.loading = false;
            })
        },
        loadDataFinish(success, data) {
            if (success) {
                this.listData = data;
            } else {
                this.listData = [];
            }
        },
        onDownload(item) {
            ExclusiveApi.downloadExportTask({
                taskId: item.taskId,
                serviceName: item.serviceName,
                tenantId: this.tenantId,
            }).then(res => {
                const contentDisposition = res.headers['content-disposition'];
                let fileName = '';
                
                if (contentDisposition) {
                    const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                    if (filenameMatch && filenameMatch[1]) {
                        fileName = decodeURIComponent(filenameMatch[1].replace(/['"]/g, ''));
                    }
                }
                utils.downloadFileByBlob(res.data, fileName);
            }).catch(err => {
                this.$message.error(err.message || "下载失败")
            })
        },
        onDelete(item) {
            this.$confirm('确认删除任务?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                ExclusiveApi.cancelExportTask({
                    taskId: item.taskId,
                    serviceName: item.serviceName,
                    statusName: "DEL",
                    tenantId: this.tenantId,
                }).then(() => {
                    this.listData = this.listData.filter(item => item.taskId !== item.taskId);
                    this.$message.success("删除成功")
                    this.initListData();
                }).catch(err => {
                    this.$message.error(err.message || "删除失败")
                })
            })
        },
    },
    computed: {
        popperOptions() {
            return {
                "boundariesElement": this.boundariesElement
            }
        }
    },
}
</script>
<style lang="scss">
.export_task_popover {
    padding: 0;
    .export_task_inner {
        min-height: 100px;
    }
    .export_task__body {
        max-height: 40vh;
        overflow-y: auto;
    }
    .export_task__empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        color: #A5A9B5;
        font-size: 12px;
        padding-bottom: 10px;
        .s-iconfont {
            font-size: 24px;
        }
    }
    .export_task__header {
        padding: 10px 15px;
        display: flex;
        align-items: center;
        font-size: 14px;
    }
    .export_task__title {
        font-size: 14px;
        color: #333;
        font-weight: 700;
        letter-spacing: 0;
        font-weight: 700;
        margin: 0;
    }
    .export_task__tishi_icon {
        margin-left: 4px;
        color: #A5A9B5;
    }
    .export_task__tishi {
        font-size: 12px;
    }
    .export_task__item {
        line-height: 1;
        padding: 12px 18px;
        display: flex;
        align-items: center;
        transition: all .3s;
        &:hover {
            background-color: #F6F6F6;
            .export_task__label {
                color: #409EFE;
            }
        }
    }
    .export_task__label {
        margin: 0;
        font-size: 13px;
        transition: color .2s;
        width: 220px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    .export_task__time,
    .export_task__size {
        margin: 7px 0 0;
        font-size: 12px;
        color: #A2A2A2;
        line-height: 1 !important;
    }
    .export_task__icon {
        width: 26px;
        margin-right: 10px;
    }
    .export_task__status {
        display: flex;
        flex-direction: column;
        align-self: flex-start;
    }
    .export_task_status_label {
        position: relative;
        padding-left: 12px;
        font-size: 12px;
        &::before {
            content: "";
            position: absolute;
            top: 50%;
            left: 0;
            width: 8px;
            height: 8px;
            border-radius: 100%;
            transform: translateY(-50%);
        }
        &.COMPLETED {
            color: #25AA0E;
            &::before {
                background-color: #25AA0E;
            }
        }
        &.RUNNING,
        &.CREATE {
            color: #FB7E3A;
            &::before {
                background-color: #FB7E3A;
            }
        }
        &.FAILED {
            color: #E23333;
            &::before {
                background-color: #E23333;
            }
        }
    }
    .export_task__action {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: auto;
        .export_task__action_item {
            font-size: 16px;
            width: 20px;
            height: 20px;
            display: flex;
            align-items: center;
            cursor: pointer;
            color: #9C9C9C;
            transition: color .2s;
            &:hover {
                color: #409EFE;
            }
            & ~ .export_task__action_item {
                margin-left: 5px;
            }
        }
    }
}
.export_task__reference {
    color: #858585;
    transition: color .2s;
    cursor: pointer;
    font-size: 18px;
    &:hover {
        color: #ff7070;
    }
    &.export_task__reference_old {
        font-size: 16px;
        color: #fff;
        &:hover {
            color: #fff;
        }
    }
}
</style>